import React from 'react';

const Dashboard: React.FC = () => {
  return (
    <div>
      <h1>Dashboard</h1>
      <p>Welcome to your dashboard! Here you can manage your activities and view important information.</p>
    </div>
  );
};

export default Dashboard;